import { CacheHandler } from "reusable/utils/cache";

export const regionCache = {
   region: new CacheHandler<string>({ key: 'GapAppRegion', cacheLocation: 'localStorage' }),
}
